import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { IState } from '../../store/reducers';
import {ApiStatus, SearchType} from '../../models';
import {
  search,
  toggleShowSearch,
  resetSearch,
} from '../../store/actions/searchActions';
import { MainSearchComponent } from './MainSearh';

import './MainSearch.scss';

interface IMainSearchContainerProps {}

const MainSearchContainerComponent = ({

}: IMainSearchContainerProps) => {
  const showSearch = useSelector((state: IState) => state.search.show);
  const results = useSelector((state: IState) => state.search.results);
  const totalResults = useSelector((state: IState) => state.search.totalResults);
  const loadingStatus = useSelector((state: IState) => state.search.loadingStatus);
  const dispatch = useDispatch();
  const history = useHistory();

  const onClose = () => {
    dispatch(toggleShowSearch());
  };

  const onSelect = (item: any) => {
    dispatch(toggleShowSearch()); // close search component

    if (!item) {
      return
    }

    const itemType: string = item.itemType;

    switch (itemType) {
      case SearchType.REPORT:
        history.push(`/r/redirect/${item.uid}/${item.type}`); // see implementation for /redirect/
        break;
    }
  };

  const onSearch = (text: string) => {
    if (text !== '') {
      if (text.trim().length > 1) {
        // search at least 2 characters
        dispatch(search(text));
      }
    } else {
      dispatch(resetSearch());
    }
  }

  return (
    <MainSearchComponent
      show={showSearch}
      results={results}
      totalResults={totalResults}
      onSearch={onSearch}
      loading={loadingStatus === ApiStatus.LOADING}
      onSelect={onSelect}
      onClose={onClose}
    />
  )
};

export const MainSearchContainer = React.memo(MainSearchContainerComponent);
